export default __webpack_public_path__ + "static/media/step-1-welcome.de73032a.png";